<button mat-icon-button [matTooltip]="tooltip" [color]="color" (click)="onClick()">
    <img src="assets/images/icons/icon-delete.png" alt="Button Image" height="10">
</button>
